// extracted by mini-css-extract-plugin
export default {"Conteneur":"InterfaceClient_Conteneur__l2qKc","ConteneurProjet":"InterfaceClient_ConteneurProjet__Idl86"};